import { Component} from '@angular/core';

@Component({
  selector: 'lib-save-svg',
  templateUrl: './save.component.svg',
  styleUrls: ['./save.component.css']
})
export class SaveSvgComponent {
  fillColor = 'rgb(84, 104, 202)';
  download() {
    console.log();
  }
}

